import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import '@/assets/font/iconfont.css'
import { createPinia } from 'pinia' // 导入Pinia
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate' // 导入持久化插件

// 导入 ResizeObserver 修复工具（必须在其他导入之前）
import '@/utils/resizeObserverFix'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/styles/app.less'
import zhCn from "element-plus/es/locale/lang/zh-cn"

const pinia = createPinia() 
pinia.use(piniaPluginPersistedstate) // 使用持久化插件

const app = createApp(App)
app.use(ElementPlus,{locale:zhCn})
app.use(pinia)
import { useMenuStore } from '@/store/menuStore' // 导入菜单store
import addDynamicRoutes from '@/utils/addRoutes' // 导入动态路由函数

// 初始化动态路由
const initDynamicRoutes = () => {
  let token = sessionStorage.getItem('wuyetoken');
  // 如果sessionStorage中没有token，尝试从localStorage获取
  if (!token) {
      token = localStorage.getItem('wuyetoken');
      if (token) {
          sessionStorage.setItem('wuyetoken', token); // 同步到sessionStorage
      }
  }
  
  if (token) {
    console.log('应用启动，初始化动态路由');
    const menuStore = useMenuStore();
    
    try {
      // 从localStorage加载菜单数据
      const menus = menuStore.loadMenusFromStorage();
      if (menus.length > 0) {
        // 添加动态路由
        addDynamicRoutes(router, menus);
        // 存储到Pinia
        menuStore.setMenus(menus);
        console.log('动态路由初始化完成');
      }
    } catch (error) {
      console.error('动态路由初始化失败:', error);
    }
  }
};

// 初始化动态路由
initDynamicRoutes();

app.use(router)

// 全局错误处理（ResizeObserver 相关错误已在修复工具中处理）
app.config.errorHandler = (err: any, instance: any, info: string) => {
  // 过滤掉 ResizeObserver 和 getBoundingClientRect 相关错误
  if (err && err.message && (
    err.message.includes('ResizeObserver') ||
    err.message.includes('getBoundingClientRect is not a function') ||
    err.message.includes('Cannot read properties')
  )) {
    return;
  }
  console.error('Vue Error:', err, info);
};

// 全局警告处理（ResizeObserver 相关警告已在修复工具中处理）
app.config.warnHandler = (msg: string, instance: any, trace: string) => {
  // 过滤掉 ResizeObserver 和 getBoundingClientRect 相关警告
  if (msg && (
    msg.includes('ResizeObserver') ||
    msg.includes('getBoundingClientRect is not a function') ||
    msg.includes('Cannot read properties') ||
    msg.includes('Runtime directive used on component with non-element root node') ||
    msg.includes('The directives will not function as intended') ||
    msg.includes('Invalid prop: custom validator check failed for prop "role"') ||
    msg.includes('Invalid prop: custom validator check failed') ||
    msg.includes('Invalid prop: validation failed for prop "role"') ||
    msg.includes('label act as value is about to be deprecated') ||
    msg.includes('type.text is about to be deprecated') ||
    msg.includes('please use link instead') ||
    msg.includes('please use value instead') ||
    msg.includes('ElementPlusError') ||
    msg.includes('Expected one of') ||
    msg.includes('got value') ||
    msg.includes('[props] [API]') ||
    msg.includes('is about to be deprecated in version 3.0.0') ||
    msg.includes('button.html#button-attributes') ||
    msg.includes('checkbox.html') ||
    msg.includes('For more detail, please visit:') ||
    msg.includes('[el-checkbox] [API]') ||
    msg.includes('label act as value') ||
    msg.includes('please use value instead')
  )) {
    return;
  }
  console.warn('Vue Warning:', msg, trace);
};

app.mount('#app')





